import Axios from 'axios';
import { Modal,Message } from "iview";
import store from '../store';
import { getToken } from './auth';

import {getBaseUrl} from "./public";


// 创建axios实例
const service = Axios.create({
  baseURL: getBaseUrl(),
  timeout: 60000,
})

// 拦截请求
service.interceptors.request.use(config => {
    if(store.getters.token){
        config.headers['Access-Token'] = getToken();
    }
    // config.cancelToken=source.token
    return config;
}, error => {
    Message.info('请求超时...')
    Promise.reject(error)
})

// 拦截响应
service.interceptors.response.use(
    response => {
        const res = response.data;

        if(res.code !== 0){
            // session过期
            if(res.code === -1){
                Modal.confirm({
                    title:'信息提示',
                    content:'<h3>超时自动登出，您可以重新登录系统</h3>',
                    okText:'重新登录',
                    cancelText:'取消',
                    onOk: () => {
                        store.dispatch('Logout').then(res => {
                            location.reload();
                        })
                    }
                })
            }else{
                //  console.log(res)
                Message.error({
                    content:res.message
                })
            }
            return Promise.reject('error');
        }else{
            return res;
        }
    }, error => {
        console.log(error);
        Message.error({
            content:error.message
        })
        return Promise.reject(error);
    }
)

// post 表单提交方式
function postFrom(url,data) {
    return service({
        method: 'POST',
        url,
        data,
        transformRequest: [function (data) {
            let ret = ''
            for (const it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
            }],
            headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

// 获取文件流
const getBlob = Axios.create({
    baseURL: getBaseUrl(),
    responseType: 'blob',
    timeout: 15000
})
// 拦截请求
getBlob.interceptors.request.use(config => {
    if(store.getters.token){
        config.headers['Access-Token'] = getToken();
    }
  config.cancelToken = store.getters.source.token
    return config;
}, error => {
    Message.info('请求超时...')
    Promise.reject(error)
})

getBlob.interceptors.response.use( response => {

    const res = response.data;
    if(response.headers.hasOwnProperty('content-type')&&response.headers['content-type'].indexOf('x-download') === -1){
        const reader = new FileReader();
        reader.readAsText(res);
        reader.onload = (e => {
            const data = JSON.parse(e.target.result);
            Message.error({
                content:data.message
            })
        })

        return Promise.reject('error');
    }else{
        return response;
    }

} )






//上线前调整下载限制、、
// 获取文件流
const getBlob2 = Axios.create({
  baseURL: getBaseUrl(),
  responseType: 'blob',
  timeout: 15000
})
// 拦截请求
getBlob2.interceptors.request.use(config => {
  if(store.getters.token){
    config.headers['Access-Token'] = getToken();
  }
  return config;
}, error => {
  Message.info('请求超时...')
  Promise.reject(error)
})

getBlob2.interceptors.response.use( response => {
  if(response.headers['content-type'].indexOf('x-download') === -1){
    Message.error({
      content:'导出失败'   //使用后端返回message？？
    })
    return Promise.reject('error');
  }else{
    return response;
  }

} )


export {getBlob,getBlob2,postFrom}

export default service;



